var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "left-card-container" },
    [
      _vm.showObjectsTable
        ? _c("div", { staticClass: "right-side-title-actions" }, [
            _c("span", { staticClass: "left-title" }, [
              _vm._v(_vm._s(_vm.$tc("Object", 2)))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "actions-container" }, [
              _c(
                "div",
                { staticClass: "search-container" },
                [
                  _c(
                    "div",
                    { staticClass: "action-buttons mr-4" },
                    [
                      _c("custom-button", {
                        attrs: {
                          label: _vm.$t("DeleteAll"),
                          "button-color": "var(--app-primary-base)",
                          "label-color": "#FFF",
                          disabled: false
                        },
                        on: { buttonClick: _vm.handleDeleteAllDialog }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-icon", [_vm._v(" search ")]),
                  _vm._v(" "),
                  _c("InputField", {
                    attrs: {
                      inputType: "text",
                      value: _vm.search,
                      placeholder: _vm.$t("Search"),
                      inputStyle: {
                        borderRadius: "0px",
                        width: "130px",
                        borderTop: "none",
                        borderRight: "none",
                        borderLeft: "none",
                        borderBottom: "1px solid rgba(118, 118, 118, 0.50)"
                      }
                    },
                    on: {
                      input: function($event) {
                        return _vm.handleSearch($event)
                      }
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "table-div-container",
          class: {
            "table-div-container": _vm.showObjectsTable,
            "table-div-container-empty": !_vm.showObjectsTable
          }
        },
        [
          !_vm.showObjectsTable
            ? _c("div", { staticClass: "empty-table" }, [
                _c("p", [_vm._v(_vm._s(_vm.$t("DeleteLayersMessage")))])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("Table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showObjectsTable,
                expression: "showObjectsTable"
              }
            ],
            ref: "objectsTable",
            attrs: {
              checkbox: true,
              tdWidth: "t-small",
              loading: _vm.loading,
              headers: _vm.headers,
              items: _vm.layerObjects,
              sortable: true,
              emitRowClickBusEvent: false,
              "scroll-id": _vm.tableId
            },
            on: {
              onScrollBottom: _vm.onScrollBottom,
              onScrollTop: _vm.onScrollTop,
              sortClick: _vm.onSortClick,
              selectedRows: function($event) {
                return _vm.onCheckboxClick($event)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showObjectsTable
        ? _c(
            "div",
            { staticClass: "action-buttons" },
            [
              _c("custom-button", {
                attrs: {
                  label: _vm.$t("Cancel"),
                  type: "cancel",
                  "button-color": "#fff",
                  "label-color": "var(--app-primary-base)",
                  "button-styling": _vm.actionButtonsStylingSave
                },
                on: { buttonClick: _vm.handleCancel }
              }),
              _vm._v(" "),
              _c("custom-button", {
                attrs: {
                  label: _vm.$t("Confirm"),
                  "button-color": "var(--app-primary-base)",
                  "label-color": "#FFF",
                  disabled: _vm.selectedRows.length === 0
                },
                on: {
                  buttonClick: function($event) {
                    _vm.deleteDialogIsOpen = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.deleteDialogIsOpen,
          title: _vm.$t("DeleteObjects"),
          content: _vm.$t("DeleteObjectsMessage"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.handleDeleteDialog,
          secondaryAction: _vm.handleCancelDeleteDialog
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.confirmationDialogIsOpen,
          title: _vm.$t("DeleteObjectsPermanently"),
          content: _vm.$t("DeleteObjectsPermanentlyMessage"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "#FF0000",
          isDeleteDialog: true,
          loading: _vm.deleteLoading
        },
        on: {
          mainAction: _vm.handleDeletes,
          secondaryAction: _vm.handleCancelDeleteConfirmation
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          title: "",
          isOpen: _vm.workspaceDialogIsOpen,
          content: _vm.$t("ChangeGeomConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.handleGeomChange,
          secondaryAction: function($event) {
            _vm.workspaceDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          title: "",
          isOpen: _vm.clearAllDialogIsOpen,
          content: _vm.$t("ClearAllConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.handleClearAll,
          secondaryAction: function($event) {
            _vm.clearAllDialogIsOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a2497b5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a2497b5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Data/Delete/TableViewLayerObjects.vue
// module id = null
// module chunks = 